import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class VersionService {
  private readonly VERSION_KEY = 'appVersion';
  checkVersion(): Promise<boolean> {
    return new Promise((resolve) => {
      const currentVersion = localStorage.getItem(this.VERSION_KEY);
      const appVersion = environment.appVersion;

      if (currentVersion === null) {
        localStorage.setItem(this.VERSION_KEY, appVersion);
        resolve(true);
        return;
      }

      if (currentVersion !== appVersion) {
        localStorage.setItem(this.VERSION_KEY, appVersion);
        window.location.reload();
      } else {
        resolve(true);
      }
    });
  }
}
